// Login.js 수정 완료
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../services/auth';
import './Login.css';

function Login() {
	const [formData, setFormData] = useState({
		username: '',
		password: ''
	});
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		});
		setError('');
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		setLoading(true);

		console.log('🔐 로그인 시도:', formData);

		try {
			const response = await login(formData);
			
			console.log('✅ 로그인 성공:', response);
			console.log('📧 이메일 인증 상태:', response.user?.email_verified);
			console.log('🔑 저장된 토큰:', localStorage.getItem('access_token')?.substring(0, 30));
			
			if (response.user && response.user.email_verified === false) {
				console.log('⚠️ 이메일 미인증 사용자 → /verify-email로 이동');
				
				localStorage.setItem('temp_access_token', response.access);
				localStorage.setItem('temp_user', JSON.stringify(response.user));
				
				alert('이메일 인증이 필요합니다.\n인증 페이지로 이동합니다.');
				navigate('/verify-email');
				return;
			}
			
			console.log('✅ 이메일 인증 완료 사용자 → 홈으로 이동');
			
			// ⭐ 이벤트 2개 발생
			window.dispatchEvent(new Event('loginStateChanged'));
			window.dispatchEvent(new Event('shuffleProducts'));
			console.log('🎲 shuffleProducts 이벤트 발생!');
			
			const redirectPath = localStorage.getItem('redirectPath');
			
			setTimeout(() => {
				if (redirectPath) {
					console.log('🔄 리다이렉트:', redirectPath);
					localStorage.removeItem('redirectPath');
					navigate(redirectPath);
				} else {
					navigate('/');
				}
			}, 300);
			
		} catch (error) {
			console.error('❌ 로그인 실패:', error);

			if (error.response) {
				console.log('서버 에러:', error.response.status, error.response.data);
				
				if (error.response.status === 401) {
					setError('아이디 또는 비밀번호가 올바르지 않습니다.');
				} else if (error.response.status === 403) {
					setError('계정이 비활성화되었습니다. 관리자에게 문의하세요.');
				} else if (error.response.data.detail) {
					setError(error.response.data.detail);
				} else if (error.response.data.error) {
					setError(error.response.data.error);
				} else {
					setError('로그인에 실패했습니다. 다시 시도해주세요.');
				}
			} else if (error.request) {
				console.log('응답 없음:', error.request);
				setError('서버와 연결할 수 없습니다. Django 서버가 실행 중인지 확인하세요.');
			} else {
				console.log('요청 에러:', error.message);
				setError('요청 중 오류가 발생했습니다.');
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="login-container">
			<div className="login-box">
				<h2>로그인</h2>

				{error && (
					<div className="error-message">
						{error}
					</div>
				)}

				<form onSubmit={handleSubmit} autoComplete="off">
					<div className="form-group">
						<label>아이디</label>
						<input
							type="text"
							name="username"
							value={formData.username}
							onChange={handleChange}
							required
							placeholder="아이디를 입력하세요"
							autoComplete="off"
						/>
					</div>

					<div className="form-group">
						<label>비밀번호</label>
						<input
							type="password"
							name="password"
							value={formData.password}
							onChange={handleChange}
							required
							placeholder="비밀번호를 입력하세요"
							autoComplete="new-password"
						/>
					</div>

					<button
						type="submit"
						className="btn-login"
						disabled={loading}
					>
						{loading ? '로그인 중...' : '로그인'}
					</button>
				</form>

				<div className="find-links">
					<Link to="/find-username">아이디 찾기</Link>
					<span className="divider">|</span>
					<Link to="/find-password">비밀번호 찾기</Link>
				</div>

				<div className="login-footer">
					<p>
						계정이 없으신가요? <Link to="/register">회원가입</Link>
					</p>
				</div>
			</div>
		</div>
	);
}

export default Login;